<template>
  <div class="home">
    <browse-home :demo="false" />
  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>

<style lang="scss" scoped>
</style>
